// extracted by mini-css-extract-plugin
export default {"HelpText":"LoginMain_HelpText__eWGQj","CompanyLogo":"LoginMain_CompanyLogo__SLxVK"};